export default {
  name: 'bs-dropdown-divider',
  render (h) {
    return h('div', {
      staticClass: 'dropdown-divider'
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/divider.js